module.exports = __webpack_public_path__ + "img/settings_240.10ebbc41.webp";